import { Form, Tag } from "antd";

const Dummy = props => {
  const parseValue = (val) => {
    if (typeof val === "string" || typeof val === "number") {
      return val
    } else if (typeof val === "object") {
      return (
        <>
          { val.map((_val, i) => <Tag key={`${props.id}-${i}`}>{ _val }</Tag>) }
        </>
      )
    }
  }
  return( <div style={{ paddingLeft: 12 }}>{parseValue(props.value)}</div>);
}

export const InterventionFormItem = props => {

  const { editing, quarters, rowIndex, ...rest } = props;

  const renderChild = () => {
    if (props.name[1] === 'qname') {
      return props.children
    } else if (editing) {
      return props.children
    } else {
      return <Dummy {...props} />
    }
  }

  return (
    <Form.Item
      noStyle
      {...rest}
    >
      { renderChild(props) }
    </Form.Item>
  );
};
